import type { BlockResponse, RuleResponse } from '@/entities/expert-report';

/**
 * Правило подходит под условие поиска: отбор идёт по тому, что видно в правиле, — его названию
 * и тексту. Условие ожидается уже приведённым к нижнему регистру; пустое подходит любому правилу.
 */
export const ruleMatchesSearch = (rule: RuleResponse, search: string): boolean =>
  !search || rule.name.toLowerCase().includes(search) || rule.text.toLowerCase().includes(search);

/** Есть ли в блоках, считая вложенные, хоть одно живое правило под условием поиска */
export const blocksHaveMatchingRules = (blocks: BlockResponse[], search: string): boolean =>
  blocks.some(
    (block) =>
      !block.isDeleted &&
      (block.rules.some((rule) => !rule.isDeleted && ruleMatchesSearch(rule, search)) ||
        blocksHaveMatchingRules(block.children, search)),
  );
